import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useCommonApi } from '../../../api';
import { onSuccessCustomApiResponse } from '../../../api/utils';
import { ACCIDENT_SOURCE } from '../../types/accident';

export const useRegistry = () => {
  const [removeDialogItemId, setRemoveDialogItemId] = useState<number | null>(null);

  const { mutate: removeItem, isPending: isRemovingItem } = useMutation(useCommonApi().removeRegistryItem());
  const { mutate: editItem, isPending: isEditingItem } = useMutation(useCommonApi().editRegistryItem());
  const { mutate: createItem, isPending: isCreatingItem } = useMutation(useCommonApi().createRegistryItem());

  const handleRemoveRegistryItem = (registryType: ACCIDENT_SOURCE) => {
    if (!removeDialogItemId) return;
    removeItem(
      {
        registryId: removeDialogItemId,
        registryType: registryType
      },
      {
        onSuccess: onSuccessCustomApiResponse({
          executed: () => setRemoveDialogItemId(null)
        })
      }
    );
  };

  return {
    removeDialogItemId,
    setRemoveDialogItemId,
    handleRemoveRegistryItem,
    isRemovingItem,
    editItem,
    isEditingItem,
    createItem,
    isCreatingItem
  };
};
